import { formatPeriodUnit } from "@utils/formatUnit";
import { CurrencyMap } from "../../utils/getPlanDetails";
import { PlanCheckbox } from "../svg";
import styles from "./styles.module.scss";
import { PriceArrow } from "@assets/Icons";
import { getFunnelType, getPaywallType } from "src/appConfig";

export const PlanItem = ({
  trialPeriodDuration,
  trialPeriodUnit,
  trialPriceAmount,
  trialNoDiscountPriceAmount,
  trialNoDiscountDailyPriceAmount,
  trialDailyPriceAmount,
  title,
  priceOld,
  priceNew,
  perDay,
  perDayOld,
  planHeader,
  checked,
  onClick,
  currency,
  discountPercentage,
  isDiscounted,
  hasTrial,
  isLegacyPlan,
  trialDiscountPercentage,
  variant,
}) => {
  const isTrial = hasTrial;
  const isWalky = getPaywallType().toLowerCase().includes("walky");
  const isQuiz =
    getPaywallType() === "QUIZ_PAYWALL" ||
    getPaywallType() === "QUIZ_PAYWALL_V2";
  const showSaleLabel = (isQuiz || isWalky) && !isTrial && isDiscounted;
  const planTitle = isTrial
    ? `${formatPeriodUnit(trialPeriodDuration, trialPeriodUnit)} Trial`
    : title;

  const finalPriceOld =
    isLegacyPlan && !isTrial ? priceOld : trialNoDiscountPriceAmount;

  const finalPriceNew = isLegacyPlan && !isTrial ? priceNew : trialPriceAmount;

  const finalPerDayOld =
    isLegacyPlan && !isTrial ? perDayOld : trialNoDiscountDailyPriceAmount;

  const finalPerDayNew =
    isLegacyPlan && !isTrial ? perDay : trialDailyPriceAmount;

  return (
    <div
      className={
        checked && isWalky
          ? `${styles.plan} ${styles.checkedWalky}`
          : checked
          ? `${styles.plan} ${styles.checked}`
          : `${styles.plan}`
      }
      onClick={onClick}
    >
      <div className={styles.container}>
        {planHeader && <div className={styles.planHeader}>{planHeader}</div>}
        <div className={styles.planContent}>
          <div className={styles.price}>
            <PlanCheckbox checked={checked} isWalky={isWalky}/>
            <div className={styles.priceText}>
              <h3>{planTitle}</h3>
              {isTrial && <div className={styles.trialPlanTitle}>{title}</div>}
              {showSaleLabel && (
                <div className={styles.discountLabel}>
                  SAVE{" "}
                  {isLegacyPlan ? discountPercentage : trialDiscountPercentage}{" "}
                  %
                </div>
              )}
              <p>
                {isDiscounted ? (
                  <span className={styles.priceValues}>
                    <span className={styles.priceOld}>
                      {CurrencyMap[currency]}
                      {finalPriceOld}
                    </span>{" "}
                    <PriceArrow /> {CurrencyMap[currency]}
                    {finalPriceNew}
                  </span>
                ) : (
                  <>
                    {CurrencyMap[currency]}
                    {finalPriceOld}
                  </>
                )}
              </p>
            </div>
          </div>
          <div className={styles.pricePerDay}>
            {isDiscounted && (
              <p className={styles.perDayOld}>
                {CurrencyMap[currency]}
                <span className={styles.strikethrough}>{finalPerDayOld}</span>
              </p>
            )}
            <p>
              {CurrencyMap[currency]}
              {isDiscounted ? finalPerDayNew : finalPerDayOld}
            </p>

            <p className={styles.perDay}>per day</p>
          </div>
        </div>
      </div>
    </div>
  );
};
